import { sanitizeHtml } from '@r/utils/sanitize-html.ts';
import { cn } from '@r/utils/utils.ts';

const ALLOWED_TAGS = ['p', 'br', 'strong', 'b', 'em', 'i', 'ul', 'li', 'a'];

interface RichTextProps {
  html: string | null | undefined;
  className?: string;
}

/**
 * Rendu assaini d'un contenu HTML produit par l'éditeur enrichi (Tiptap).
 * DOMPurify limite les balises à celles que l'éditeur peut générer.
 */
export function RichText({ html, className }: RichTextProps) {
  if (!html) return null;

  const clean = sanitizeHtml(html, { allowedTags: ALLOWED_TAGS });
  if (!clean.replace(/<[^>]*>/g, '').trim() && !clean.includes('<br')) return null;

  return (
    <div
      className={cn(
        'text-sm leading-relaxed [&_a]:text-primary [&_a]:underline [&_li]:my-0.5 [&_p]:my-0 [&_p:not(:first-child)]:mt-2 [&_ul]:my-1 [&_ul]:list-disc [&_ul]:pl-5',
        className
      )}
      // Contenu assaini par DOMPurify juste au-dessus.
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
